import VideoDetailScreen from './VideoDetailScreen'

export default VideoDetailScreen
